import {
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
} from 'constants/siteStatuses'

export const isEditOnlySite = (site = {}) => {
  return site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID ||
    site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
}

export const resolveHistoryId = (editOnly, site = {}, params = {}) => {
  const fromParams =
    params?.siteHistoryId ??
    params?.sitehistoryId ??
    params?.historyId ??
    params?.HistoryId ??
    params?.history_id

  const fromSiteFlat =
    site?.sitehistoryId ??
    site?.siteHistoryId ??
    site?.SiteHistoryId ??
    site?.historyId ??
    site?.HistoryId ??
    site?.history_id ??
    site?.currentSiteHistoryId ??
    site?.currentHistoryId

  const fromSiteNested =
    site?.SiteHistory?.id ??
    site?.siteHistory?.id ??
    site?.history?.id ??
    site?.History?.id

  if (editOnly) {
    return fromSiteFlat ?? fromSiteNested ?? null
  }

  return fromParams ?? fromSiteFlat ?? fromSiteNested ?? null
}

/**
 * History id for loading trigger lists (species, ecosystems, criterion C/E, congregations).
 * View on a live site opens the parent Site with no history in the URL, so fall back to the
 * latest live assessment; otherwise the new / existing / non-qualifying split is lost.
 */
export const resolveTriggerListHistoryId = (site = {}, params = {}) => {
  if (isEditOnlySite(site)) {
    return site?.sitehistoryId
  }

  return params?.siteHistoryId ?? site?.latestLiveHistoryId
}

export const resolveSiteId = (editOnly, site = {}, params = {}) => {
  if (editOnly) {
    return site?.siteId ?? site?.SiteId ?? params?.id ?? site?.id ?? null
  }

  return params?.id ?? params?.siteId ?? site?.id ?? site?.SiteId ?? null
}

export const resolveSiteWorkflowContext = (site = {}, params = {}) => {
  const editOnly = isEditOnlySite(site)
  const siteId = resolveSiteId(editOnly, site, params)
  const historyId = resolveHistoryId(editOnly, site, params)

  return {
    siteId,
    historyId,
    editOnly,
    isReassessment: Boolean(historyId) && !editOnly
  }
}
